"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Loom = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M12 4a5 5 0 00-4 8 7 7 0 017-7 4.979 4.979 0 00-3-1zm0 10a4.992 4.992 0 01-1.703-.297A4.99 4.99 0 0110 12c0-.598.105-1.171.297-1.703A4.99 4.99 0 0112 10c.598 0 1.171.105 1.703.297.192.53.297 1.104.297 1.703 0 .598-.105 1.171-.297 1.703A4.989 4.989 0 0112 14zm0 2a7 7 0 01-7-7 5 5 0 007 7zM5.782 5.782A7 7 0 0112 2a7 7 0 016.218 3.782A7 7 0 0122 12a7 7 0 01-3.782 6.218A7 7 0 0112 22a7 7 0 01-6.218-3.782A7 7 0 012 12a7 7 0 013.782-6.218zM8.999 19a5 5 0 007-7h.001a7 7 0 01-7 7zm3-11a5 5 0 017 7 7 7 0 00-6.999-7z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Loom;
